enum EServiceEngineerActions {
    INITIALIZED = '@serviceEngineer/initialized',

    SET_DELIVERY_OPTIONS = '@serviceEngineer/set/deliveryOptions',

    SELECT_DELIVERY_OPTION = '@serviceEngineer/select/deliveryOption',

    SELECT_DATE = '@serviceEngineer/select/date',
    FLUSH_HOUR = '@serviceEngineer/flush/hour',
    SELECT_HOUR = '@serviceEngineer/select/hour',

    SET_COMMENT = '@serviceEngineer/set/comment',
    SET_ERROR_MESSAGE = '@serviceEngineer/set/errorMessage',

    CONFIRM = '@serviceEngineer/confirm',

    SET_SLOTS = '@serviceEngineer/set/timeSlots',
    UPDATE_HOURS_FOR_DAY = '@serviceEngineer/update/hoursForDay',
    SET_IS_LOADING = '@serviceEngineer/loadingState/set',

    REQUEST_SLOTS = '@serviceEngineer/slots/request',

    CHANGE_SELECTED_SLOT_STATE = '@serviceEngineer/slots/change/slotState',
}

export default EServiceEngineerActions;
